import { space } from '../spacing.js';
export const listBase = {
    spaceBetween: space.x4,
};
export const listItemWithSeperator = {
    paddingBottom: space.x3,
    boxShadow: {
        style: 'inset',
        color: 'default',
        alpha: 'full',
    },
};
//# sourceMappingURL=list.js.map